import React from "react";
import { FormattedMessage } from "react-intl";
import PropTypes from "prop-types";

import { SectionHeader } from "../sectionHeader/SectionHeader";
import { Input } from "../../../../components/input/Input";
import { useIntlTranslate } from "../../../../hooks";

import "./AdminInfo.scss";

export const AdminInfo = ({ email, phone }) => {
  const translate = useIntlTranslate();

  return (
    <fieldset className="form-section">
      <SectionHeader title={<FormattedMessage id={"admin_contacts"} />}>
        <FormattedMessage id={"provide_admin_contacts_description"} />
      </SectionHeader>
      <div className="admin-info">
        <Input
          id="admin-email-input"
          data-testid="admin-email"
          className="admin-info__field"
          onChange={(e) => email.action(e.target.value)}
          onClear={() => email.action("")}
          value={email.value || ""}
          placeholder={translate("email_placeholder")}
          label={<FormattedMessage id="admin_email" />}
          error={
            email.isEmailPatternValid === false && (
              <FormattedMessage id="email_error" />
            )
          }
          {...(email.validation && { maxLength: email.validation.maxLength })}
          showLimit={false}
        />
        <Input
          id="admin-phone-input"
          data-testid="admin-phone"
          className="admin-info__field"
          onChange={(e) => phone.action(e.target.value)}
          onClear={() => phone.action("")}
          value={phone.value || ""}
          placeholder={translate("phone_number_placeholder")}
          label={<FormattedMessage id="admin_phone_number" />}
          {...(phone.validation && { maxLength: phone.validation.maxLength })}
          showLimit={false}
        />
      </div>
    </fieldset>
  );
};

AdminInfo.propTypes = {
  email: PropTypes.shape({
    value: PropTypes.string,
    action: PropTypes.func.isRequired,
    validation: PropTypes.object,
    isEmailPatternValid: PropTypes.bool,
  }).isRequired,
  phone: PropTypes.shape({
    value: PropTypes.string,
    action: PropTypes.func.isRequired,
    validation: PropTypes.object,
  }).isRequired,
};
